/**
 * Single source of truth for default font family names.
 * Change these constants when switching to a different default font across the app.
 * Keep styles/global.scss $default-primary-font-family in sync for @font-face and body.
 */
export const DEFAULT_PRIMARY_FONT_FAMILY = 'Default Font';
export const DEFAULT_PRIMARY_SEMIBOLD_FONT = 'Default Font SemiBold';
export const DEFAULT_PRIMARY_BOLD_FONT = 'Default Font Bold';
export const DEFAULT_PRIMARY_REGULAR_FONT = 'Default Font Regular';
export const DEFAULT_SECONDARY_FONT_FAMILY = 'Default Font';
